import { gql } from '../../utils/helper';

export const getStories = gql`
  query getStories(
    $entityId: Int!
    $order: [stories_order_by!]
    $limit: Int!
    $offset: Int!
    $state: storyStates_enum
    $opengovId: Int
    $title: String
  ) {
    count: stories_aggregate(
      where: {
        deletedAt: { _is_null: true }
        state: { _eq: $state }
        author: { opengovId: { _eq: $opengovId } }
        title: { _ilike: $title }
        entityId: { _eq: $entityId }
      }
    ) {
      aggregate {
        count
      }
    }
    resources: stories(
      order_by: $order
      limit: $limit
      offset: $offset
      where: {
        deletedAt: { _is_null: true }
        state: { _eq: $state }
        author: { opengovId: { _eq: $opengovId } }
        title: { _ilike: $title }
        entityId: { _eq: $entityId }
      }
    ) {
      _id
      createdAt
      createdBy
      entityId
      deletedAt
      description
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedBy
      visibility
      author {
        firstName
        lastName
        email
        opengovId
        _id
      }
      folder {
        publicationId
        id
        title
      }
      publishedAt
      publishedBy
      storyKey
      folderId
      publicUrl
    }
  }
`;

export const getStoriesInPublication = gql`
  query getStoriesInPublication(
    $folderIds: [uuid!]
    $entityId: Int!
    $order: [stories_order_by!]
    $limit: Int!
    $offset: Int!
    $state: storyStates_enum
    $opengovId: Int
    $title: String
  ) {
    count: stories_aggregate(
      where: {
        deletedAt: { _is_null: true }
        folderId: { _in: $folderIds }
        entityId: { _eq: $entityId }
        state: { _eq: $state }
        author: { opengovId: { _eq: $opengovId } }
        title: { _ilike: $title }
      }
    ) {
      aggregate {
        count
      }
    }
    resources: stories(
      order_by: $order
      limit: $limit
      offset: $offset
      where: {
        deletedAt: { _is_null: true }
        folderId: { _in: $folderIds }
        entityId: { _eq: $entityId }
        state: { _eq: $state }
        author: { opengovId: { _eq: $opengovId } }
        title: { _ilike: $title }
      }
    ) {
      _id
      createdAt
      createdBy
      entityId
      description
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedBy
      visibility
      author {
        firstName
        lastName
        email
        opengovId
        _id
      }
      publishedAt
      publishedBy
      storyKey
      folderId
    }
  }
`;

export const getTemplates = gql`
  query getTemplates(
    $entityId: Int
    $order: [storyTemplates_order_by!]
    $limit: Int!
    $offset: Int!
    $opengovId: Int
    $title: String
  ) {
    count: storyTemplates_aggregate(
      where: { entityId: { _eq: $entityId }, author: { opengovId: { _eq: $opengovId } }, title: { _ilike: $title } }
    ) {
      aggregate {
        count
      }
    }
    resources: storyTemplates(
      order_by: $order
      limit: $limit
      offset: $offset
      where: { entityId: { _eq: $entityId }, author: { opengovId: { _eq: $opengovId } }, title: { _ilike: $title } }
    ) {
      _id
      description
      entityId
      paddingBottom
      paddingTop
      publishedAt
      publishedBy
      createdAt
      createdBy
      updatedAt
      updatedBy
      thumbnailRelativePath
      state
      thumbnail
      title
      visibility
      customCssCode
      author {
        _id
        email
        firstName
        lastName
        opengovId
      }
    }
  }
`;

export const moveFolders = gql`
  mutation moveFolders($ids: [uuid!], $parentFolderId: uuid!) {
    update_storyFolders(where: { id: { _in: $ids } }, _set: { parentFolderId: $parentFolderId, order: 0 }) {
      affected_rows
      returning {
        id
        title
      }
    }
  }
`;

export const getStoriesInFolder = gql`
  query getStories(
    $entityId: Int!
    $order: [stories_order_by!]
    $limit: Int
    $offset: Int
    $state: storyStates_enum
    $opengovId: Int
    $title: String
    $folder: uuid
  ) {
    count: stories_aggregate(
      where: {
        deletedAt: { _is_null: true }
        entityId: { _eq: $entityId }
        state: { _eq: $state }
        author: { opengovId: { _eq: $opengovId } }
        title: { _ilike: $title }
        folder: { id: { _eq: $folder } }
      }
    ) {
      aggregate {
        count
      }
    }
    resources: stories(
      order_by: $order
      limit: $limit
      offset: $offset
      where: {
        deletedAt: { _is_null: true }
        entityId: { _eq: $entityId }
        state: { _eq: $state }
        author: { opengovId: { _eq: $opengovId } }
        title: { _ilike: $title }
        folder: { id: { _eq: $folder } }
      }
    ) {
      _id
      createdAt
      createdBy
      entityId
      description
      order
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      updatedBy
      visibility
      author {
        firstName
        lastName
        email
        opengovId
        _id
      }
      publishedAt
      publishedBy
      storyKey
      folderId
      publicUrl
    }
  }
`;

export const getStoryCountInFolders = gql`
  query getStoryCountByFolderIds($folderIds: [uuid!]) {
    count: stories_aggregate(where: { deletedAt: { _is_null: true }, folder: { id: { _in: $folderIds } } }) {
      aggregate {
        count
      }
    }
  }
`;

export const createStory = gql`
  mutation createStory($story: stories_insert_input!) {
    insert_stories_one(object: $story) {
      _id
      createdAt
      createdBy
      description
      entityId
      folderId
      state
      title
      updatedAt
      updatedBy
      storyKey
      author {
        title
        _id
        firstName
        lastName
        email
        opengovId
      }
    }
  }
`;

export const moveStories = gql`
  mutation moveStoriesById($ids: [String!] = "", $folderId: uuid!) {
    update_stories(where: { _id: { _in: $ids } }, _set: { folderId: $folderId }) {
      affected_rows
    }
  }
`;

export const moveStoriesByFolderId = gql`
  mutation moveStoriesByFolderId($currentFolderId: uuid! = "", $targetFolderId: uuid!) {
    update_stories(where: { folderId: { _eq: $currentFolderId } }, _set: { folderId: $targetFolderId }) {
      affected_rows
    }
  }
`;

export const deleteStories = gql`
  mutation deleteStoriesById($ids: [String!] = "") {
    delete_publicationNavigationMenuStories(where: { storyId: { _in: $ids } }) {
      affected_rows
    }
    update_stories(where: { _id: { _in: $ids } }, _set: { deletedAt: "now()" }) {
      affected_rows
    }
  }
`;

export const deleteStoriesAndFolderByFolderIds = gql`
  mutation deleteStoriesAndFolderByFolderIds($folderIds: [uuid!]) {
    update_stories(where: { folderId: { _in: $folderIds } }, _set: { deletedAt: "now()" }) {
      affected_rows
    }
    update_storyFolders(where: { id: { _in: $folderIds } }, _set: { deletedAt: "now()" }) {
      affected_rows
    }
  }
`;

export const upsertStoryUser = gql`
  mutation UpsertStoryusers($user: storyUsers_insert_input!) {
    insert_storyUsers_one(
      object: $user
      on_conflict: { constraint: storyUsers_og_id_key, update_columns: [firstName, lastName, email, title] }
    ) {
      _id
    }
  }
`;

export const getTemplateById = gql`
  query getTemplateById($id: String!) {
    resource: storyTemplates_by_pk(_id: $id) {
      templateContents: contents {
        content
        contentHtml
        description
        entityId
        format
        group
        layout
        order
        storyTemplateId
        title
        type
        _id
        author {
          title
          _id
          firstName
          lastName
          email
          opengovId
        }
      }
      createdAt
      createdBy
      description
      entityId
      paddingBottom
      paddingTop
      publishedAt
      publishedBy
      state
      thumbnail
      thumbnailRelativePath
      title
      updatedAt
      updatedBy
      visibility
      _id
      author {
        title
        _id
        firstName
        lastName
        email
        opengovId
      }
      customColors {
        colorTarget
        colors
        contentType
      }
      customCssCode
    }
  }
`;

export const createStoryFolder = gql`
  mutation createStoryFolder($storyFolder: storyFolders_insert_input!) {
    insert_storyFolders_one(object: $storyFolder) {
      id
      entityId
      title
      parentFolderId
    }
  }
`;

export const createStoryFolders = gql`
  mutation createStoryFolders($storyFolders: [storyFolders_insert_input!]!) {
    storyFolders: insert_storyFolders(objects: $storyFolders) {
      returning {
        id
        entityId
        title
        parentFolderId
      }
    }
  }
`;

export const renameStoryFolder = gql`
  mutation renameStoryFolder($id: uuid!, $title: String) {
    update_storyFolders_by_pk(_set: { title: $title }, pk_columns: { id: $id }) {
      title
    }
  }
`;

export const organizeStoryFolders = (orderedFoldersIds: string[]): string => {
  const query = `
        mutation reorderStoryFolders {
          ${orderedFoldersIds
      .map((folderId, index) => {
        return `
              folder_${index}: update_storyFolders_by_pk(_set: { order: ${index + 1
          } }, pk_columns: { id: "${folderId}" }) {
                id
                order
              }
            `;
      })
      .join('')}
        }
      `;

  return gql`
    ${query}
  `;
};

export const organizeStoriesInFolder = (orderedStoryIds: string[]): string => {
  const query = `
        mutation reorderStoriesInFolder {
          ${orderedStoryIds
      .map((storyId, index) => {
        return `
              story_${index}: update_stories_by_pk(_set: { order: ${index + 1} }, pk_columns: { _id: "${storyId}" }) {
                _id
                createdAt
                createdBy
                entityId
                description
                order
                state
                thumbnail
                thumbnailRelativePath
                title
                updatedAt
                updatedBy
                visibility
                author {
                  firstName
                  lastName
                  email
                  opengovId
                  _id
                }
                publishedAt
                publishedBy
                storyKey
                folderId
              }
            `;
      })
      .join('')}
        }
      `;

  return gql`
    ${query}
  `;
};

export const folderCopyProcessesSubscriptionQuery = gql`
  subscription copyProcesses($folderId: uuid!) {
    folderProcess: storyFoldersCopyProcesses_by_pk(destinationFolderId: $folderId) {
      destinationFolderId
      message
      sourceFolderId
      status
      suppressDisplayBanner
    }
  }
`;

export const storiesCopyProcessesSubscriptionQuery = gql`
  subscription storiesCopyProcesses($folderId: uuid!) {
    storiesProcesses: storiesCopyProcesses(
      where: { destinationFolderId: { _eq: $folderId } }
      order_by: { updatedAt: desc }
    ) {
      _id
      createdAt
      updatedAt
      suppressDisplayBanner
      status
      message
      destinationFolderId
      storyCopyProcesses {
        _id
        storyCopyId
        storyCopy {
          _id
          title
        }
        storySourceId
        storySource {
          _id
          title
        }
      }
    }
  }
`;

export const dismissStoryFoldersCopyProcessesBannerMutation = gql`
  mutation dismissStoryFoldersCopyProcessesBanner($folderId: uuid!) {
    process: update_storyFoldersCopyProcesses_by_pk(
      pk_columns: { destinationFolderId: $folderId }
      _set: { suppressDisplayBanner: true }
    ) {
      suppressDisplayBanner
    }
  }
`;

export const dismissExportPdfBannerMutation = gql`
  mutation dismissExportPdfBanner($id: uuid!) {
    process: update_exportFolderPdfRequests_by_pk(pk_columns: { id: $id }, _set: { suppressDisplayBanner: true }) {
      suppressDisplayBanner
    }
  }
`;

export const dismissExportPublicationPdfBannerMutation = gql`
  mutation dismissExportPublicationPdfBanner($id: uuid!) {
    process: update_publicationExportPdfRequest_by_pk(pk_columns: { id: $id }, _set: { suppressDisplayBanner: true }) {
      suppressDisplayBanner
    }
  }
`;

export const getExportPdfDetailsForFolder = gql`
  subscription exportFolderPdfRequests($folderId: uuid!) {
    exportFolderPdfRequests(where: { folderId: { _eq: $folderId } }, order_by: { createdAt: desc }, limit: 1) {
      folderId
      status
      fileUrl
      id
      createdAt
      suppressDisplayBanner
    }
  }
`;

export const dismissStoriesCopyProcessBannerMutation = gql`
  mutation dismissStoriesCopyProcessBanner($processId: String!) {
    process: update_storiesCopyProcesses_by_pk(pk_columns: { _id: $processId }, _set: { suppressDisplayBanner: true }) {
      suppressDisplayBanner
    }
  }
`;

export const getAllPublicationsInEntity = gql`
  query getAllPublicationsInEntity($entityId: Int!) {
    publications(where: { entityId: { _eq: $entityId } }) {
      id
      title
    }
  }
`;

export const getFolderHierarchyStoryCounts = gql`
  fragment storyFolderContentFields on storyFolders {
    id
    publicationId
    stories_count: stories_aggregate(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
      aggregate {
        count
      }
    }
  }
  query getFolderHierarchyStoryCounts($entityId: Int, $folderId: uuid) {
    storyFolders(where: { deletedAt: { _is_null: true }, entityId: { _eq: $entityId }, id: { _eq: $folderId } }) {
      ...storyFolderContentFields
      subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
        ...storyFolderContentFields
        subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
          ...storyFolderContentFields
          subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
            ...storyFolderContentFields
            subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
              ...storyFolderContentFields
              subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
                ...storyFolderContentFields
                subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
                  ...storyFolderContentFields
                  subFolders(where: { deletedAt: { _is_null: true } }, order_by: { order: asc }) {
                    ...storyFolderContentFields
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const getExportPdfDetailsForPublication = gql`
  subscription publicationExportPdfRequest($publicationId: uuid!) {
    publicationExportPdfRequest(
      where: { publicationId: { _eq: $publicationId } }
      order_by: { createdAt: desc }
      limit: 1
    ) {
      publicationId
      status
      fileUrl
      id
      createdAt
      suppressDisplayBanner
    }
  }
`;

export const copyPublicationSubscriptionQuery = gql`
  subscription asyncJobs($copyPublicationJobId: uuid!) {
    asyncJobs(where: { id: { _eq: $copyPublicationJobId } }) {
      id
      operationName
      operationParams
      jobStartedAt
      jobCompletedAt
      jobStatus
      errorData
      createdAt
      updatedAt
    }
  }
`;

export const populateReportEmbedSubscriptionQuery = gql`
  subscription asyncJobs($populateEmbedJobId: uuid!) {
    asyncJobs(where: { id: { _eq: $populateEmbedJobId } }) {
      id
      operationName
      operationParams
      jobStartedAt
      jobCompletedAt
      jobStatus
      errorData
      createdAt
      updatedAt
    }
  }
`;

export const bulkChangeStatusSubscriptionQuery = gql`
  subscription asyncJobs($bulkChangeStatusJobId: uuid!) {
    asyncJobs(where: { id: { _eq: $bulkChangeStatusJobId } }) {
      id
      operationName
      operationParams
      jobStartedAt
      jobCompletedAt
      jobStatus
      errorData
      createdAt
      updatedAt
    }
  }
`;
